import { inject, Injectable } from '@angular/core';
import { LoginHelper } from '../helpers/login.helper';
import { HttpInterceptorFn } from '@angular/common/http';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  const loginHelper = inject(LoginHelper);
  const token = loginHelper.get()?.token;
  if (!req.url.includes('/api/auth/Login/signin')) {
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });
    } else {
      console.warn('Token não encontrado, requisição será feita sem autenticação.');
    }
  }

  return next(req);
};
